export const AppRouting = {
  Error403: {
    path: () => "/403",
  },
  Error404: {
    path: () => "/404",
  },
  SignIn: {
    path: () => "/",
  },
  RegisterPartner: {
    path: () => "/register-partner",
  },
  RegisterActor: {
    path: () => "/register-actor",
  },
  ResetPassword: {
    path: () => "/password-reset",
  },
  SetPassword: {
    route: "/set-password/:token",
    path: (token: string) => `/set-password/${token}`,
  },
  PrivacyPolicy: {
    path: () => "/privacy",
  },
  TermsOfService: {
    path: () => "/terms",
  },
  Help: {
    path: () => "/help",
  },
  Dashboard: {
    path: () => "/dashboard",
  },
  Projects: {
    path: () => "/projects",
  },
  ProjectDetail: {
    route: "/projects/:projectId",
    path: (projectId: string) => `/projects/${projectId}`,
  },
  ProjectJobDetail: {
    route: "/projects/:projectId/jobs/:jobId",
    path: (projectId: string, jobId: string) =>
      `/projects/${projectId}/jobs/${jobId}`,
  },
  Actors: {
    path: () => "/actors",
  },
  ActorDetail: {
    route: "/actors/:actorId",
    path: (actorId: string) => `/actors/${actorId}`,
  },
  Partners: {
    path: () => "/partners",
  },
  Modules: {
    path: () => "/modules",
  },
  ModuleDetail: {
    route: "/modules/:moduleId",
    path: (moduleId: string) => `/modules/${moduleId}`,
  },
  PartnerDetail: {
    route: "/partners/:partnerId",
    path: (partnerId: number | string) => `/partners/${partnerId}`,
  },
  PriceCategories: {
    path: () => "/price-categories",
  },
  PriceCategoryDetail: {
    route: "/price-categories/:priceCategoryId",
    path: (priceCategoryId: string) => `/price-categories/${priceCategoryId}`,
  },
  MusicAudio: {
    path: () => "/music-audio",
  },
  Billing: {
    path: () => "/billing",
  },
  Clients: {
    path: () => "/clients",
  },
  ClientDetail: {
    route: "/clients/:clientId",
    path: (clientId: string) => `/clients/${clientId}`,
  },
  Users: {
    path: () => "/users",
  },
  UserDetail: {
    route: "/users/:id",
    path: (id: string) => `/users/${id}`,
  },
  WithdrawalApprovals: {
    path: () => "/withdrawal-approvals",
  },
  WithdrawalApprovalDetail: {
    route: "/withdrawal-approvals/:withdrawalRequestID",
    path: (withdrawalRequestID: string) =>
      `/withdrawal-approvals/${withdrawalRequestID}`,
  },
  Invoices: {
    path: () => "/invoices",
  },
  PartnerInvoices: {
    path: () => "/partner-invoices",
  },
  ActivityLog: {
    path: () => "/activity-log",
  },
  Reporting: {
    path: () => "/reporting",
  },
  RegistrationRequests: {
    path: () => "/registration-requests",
  },
  RegistrationRequestDetail: {
    route: "/registration-requests/:registrationRequestId",
    path: (registrationRequestId: string) =>
      `/registration-requests/${registrationRequestId}`,
  },
} as const;

type RouteObject<T extends any[] = any[]> = {
  route?: string;
  path: (...args: T) => string;
};

export function getRoute<T extends RouteObject>(routeObj: T): string {
  return routeObj.route ?? routeObj.path();
}

export function resolveStartPage(
  user: unknown | null,
  unauthenticatedUrl: string | null,
) {
  if (user === null) {
    return AppRouting.SignIn.path();
  }

  if (unauthenticatedUrl) {
    return unauthenticatedUrl;
  }
  return AppRouting.Dashboard.path();
}

export function getPathnameAndSearch(location: {
  pathname: string;
  search: string;
}) {
  return `${location.pathname}${location.search}`;
}
